module.exports = __webpack_public_path__ + "static/avril-kiss-25b0cd1a8c9c8209f393fc4f9c38e721.gif";